import * as React from 'react';
import classNames from 'classnames';
import './sideBar.module.scss';
import { observer } from 'mobx-react';
import { V3Routes, EnhancedLocationDescriptor } from '../../../routes';
import { routingStore } from '../../../../common/stores/routing';
import { useViewportState } from '../../../../commonv3/hooks/useViewportState';
import { useCurrentUserState } from '../../../../commonv3/hooks/useCurrentUserState';
import { FlagKeys } from '../../../../mainv2/states/CurrentUserState';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

const Separator = () => {
    return (
        <div styleName="separator-wrapper">
            <div styleName="separator" />
        </div>
    );
};

type MenuItemProps = {
    id?: string;
    active: boolean;
    to?: EnhancedLocationDescriptor;
    href?: string;
    children: any;
};

const MenuItem = observer(({ active, to, href, children, id }: MenuItemProps) => {
    if (href) {
        return (
            <a styleName={classNames('menu-item', { active: active })} href={href} id={id}>
                <span styleName="menu-item-text">{children}</span>
            </a>
        );
    }
    return (
        <div styleName={classNames('menu-item', { active: active })} onClick={() => routingStore.push(to)} id={id}>
            <span styleName="menu-item-text">{children}</span>
        </div>
    );
});

type Props = {
    activeMenu?: string;
};

export const SideBar = observer(({ activeMenu }: Props) => {
    const userState = useCurrentUserState();
    const viewport = useViewportState();
    const user = GlobalStatesV3.currentUser;
    return (
        <div styleName="side-bar">
            {viewport.isMobile &&
                userState.hasEnabledFlagKey(FlagKeys.COMMUNITY_SERVICE) && (
                    <>
                        <Separator />
                        <MenuItem id="menu-item-community-service" active={false} href={V3Routes.communityService()}>
                            SHEコミュニティ
                        </MenuItem>
                    </>
                )}
            <Separator />
            <MenuItem active={activeMenu == 'profile'} to={V3Routes.profile()}>
                プロフィールを編集
            </MenuItem>
            <MenuItem active={activeMenu == 'reservations'} to={V3Routes.reservations()}>
                予約の確認
            </MenuItem>
            <Separator />
            <MenuItem active={activeMenu == 'plans'} to={V3Routes.plan()}>
                プランの確認 / 変更
            </MenuItem>
            {!user.isMultiCreatorUser() && (
                <MenuItem active={activeMenu == 'multicreator'} to={V3Routes.multiCreators()}>
                    コースのアップグレード
                </MenuItem>
            )}
            <MenuItem active={activeMenu == 'home_location'} to={V3Routes.homeLocation()}>
                ホーム拠点の確認/変更
            </MenuItem>
            <MenuItem active={activeMenu == 'payments'} to={V3Routes.payments()}>
                お支払い情報 / 変更
            </MenuItem>
            <MenuItem active={activeMenu == 'password'} to={V3Routes.password()}>
                パスワードを変更
            </MenuItem>
            <MenuItem active={activeMenu == 'email'} to={V3Routes.email()}>
                メールの設定
            </MenuItem>
            <MenuItem active={false} to={V3Routes.faq()}>
                よくあるご質問
            </MenuItem>
            <MenuItem active={activeMenu == 'sign_out'} to={V3Routes.signOut()}>
                ログアウト
            </MenuItem>
        </div>
    );
});
